import { createStore } from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import * as types from './types';
//import api from './common';

const state = {
  serverApiRoot: '',
  navList: [
    { label: '사용신청', url: '/main/userApply' },
    { label: '사용자 접속 로그', url: '/main/userAuthLog' },
    { label: 'VM 사용 이력', url: '/main/userVMLog' },
    { label: 'RDP 다운로드 이력', url: '/main/rdpDownLoadLog'},
    { label: 'VM 스크립트 이력', url: '/main/scriptLog'},
    { label: '대시보드', url: '/main/dashBoard'},
    { label: '접속 직원 정보', url: '/main/userInfo' },
    { label: '공지사항', url: '/main/announcementsList' },
    { label: '팝업공지사항', url: '/main/popupAnnouncementsList' },
    { label: 'FAQ', url: '/main/faqList' },
    { label: '리소스 관리', url: '/main/resource' }
  ],
  selectNav: '',
  auth: '',
};

const getters = {
  [types.GET_SERVERAPIROOT]: (state) => {
    return state.serverApiRoot
  },
  [types.GET_USERINFO]: (state) => {
    return state.userInfo;
  },
  [types.GET_NAVLIST]: (state) => {
    return state.navList;
  },
  [types.GET_CURRNAV]: (state) => {
    return state.selectNav;
  },
  [types.GET_AUTH]: (state) => {
    return state.auth;
  }
};

const mutations = {
  [types.SET_SERVERAPIROOT]: (state, serverApiRoot) => {
    state.serverApiRoot = serverApiRoot;
  },
  [types.SET_USERINFO]: (state, userInfo) => {
    state.userInfo = userInfo;
  },
  [types.SET_CURRNAV]: (state, selectNav) => {
    state.selectNav = selectNav;
  },
  [types.SET_AUTH]: (state, auth) => {
    state.auth = auth;
  }
};

const actions = {
  // async [types.GET_USERINFO] ({ commit }, payload) {
  //   try {
  //     const response = await api.getUserInfo(state.serverApiRoot, payload);
  //     if (response.status == 200 && response.data != null) {
  //       const obj = response.data;
  //       commit(types.SET_USERINFO, obj)
  //     }
  //   } catch (error) {
  //       console.error(error);
  //   }
  // }
};

export default createStore({
  state,
  getters,
  mutations,
  actions,
  plugins: [
    createPersistedState({
      storage: sessionStorage,
      paths: ["selectNav", "auth", "serverApiRoot"],
    })
  ]
});